import { useDocumentStorageContext } from 'framework/documentStorage';
import { DropDownFilter, Filters, FiltersLayout, List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import UploadProcessAssetsButton from '../shared/buttons/UploadProcessAssetsButton';
import ProcessAssetsListContent from './ProcessAssetsListContent';
import { EnumDropdown } from 'framework/form';
import { OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES, PROCESS_ASSETS_CTO, PROCESS_ASSETS_SUPPORTS } from '../constants';
import { useAuthorization } from 'framework/authorization';
import { OfficeFilterById, EmployeeFilter } from 'domain/shared/employee';

const ProcessAssetsListPage = () => {
  const { isGranted } = useAuthorization();

  const { searchDocuments } = useDocumentStorageContext();

  const availableOwnerFilter = isGranted([PROCESS_ASSETS_CTO, PROCESS_ASSETS_SUPPORTS]);

  const filters = (
    <Filters>
      <FiltersLayout>
        <DropDownFilter source="fileType" label="Type">
          {/* Temporary now we use only HR sections */}
          <EnumDropdown source="fileType" label="Type" options={OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES} />
        </DropDownFilter>
        <OfficeFilterById source="office" label="Office" />
        <EmployeeFilter isVisible={availableOwnerFilter} source="owner" label="Owner" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List getDataMethod={searchDocuments}>
      <ListPageLayout
        header={<ListHeader label="Operational Process Assets" />}
        search={<SearchInput label="template" />}
        filter={filters}
        actions={[<UploadProcessAssetsButton />]}
      >
        <ProcessAssetsListContent />
      </ListPageLayout>
    </List>
  );
};

export default ProcessAssetsListPage;
